module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapters"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('strong', [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "h2aa"
  }, [_c('strong', [_vm._v("Your Complete Prep Guide to Wicked Good Meals")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We know it’s important to plan things, and plan them well in order to be as efficient as possible come dinnertime, especially when you have one hungry mob waiting for you to bring a steaming hot plate of deliciousness to the table.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This chapter is meant to help you accomplish the task of preparing a meal without tearing your hair out, or waving the proverbial white flag by picking up the phone to order some greasy food from the joint down the street. Show that kitchen who’s boss! And while you’re at it, hire any willing participant to come give you a hand in whipping up something tasty: The food will not only get to the table much faster, but you’ll also get to spend quality time with family members or friends you barely get to enjoy hanging out with and talking to during the busy day. Bonus!")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "chaplev01sec01"
    }
  }, [_vm._v("Things We Simply Can’t Live without in Our Kitchens")])]), _c('a', {
    attrs: {
      "id": "chaplev01sec01"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Following is a list of items we use the most, and that we acquired without breaking the bank. If you are serious about cooking, or just want to be someday, having at least a few of these items on hand is sure to make your life easier.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Baked goods pans:")]), _vm._v(" We use standard aluminized steel pans, but never glass pans, for baking, because results aren’t always satisfying with the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Cast-iron skillet:")]), _vm._v(" A good-quality cast-iron skillet just may replace half of your other pots and pans. Oven safe, naturally nonstick, long lasting, and usually inexpensive (some of the best come from garage sales and thrift stores), these pans have become indispensable in our kitchens. Try to find one with a tight-fitting lid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Deep fryer:")]), _vm._v(" While we do not advocate eating deep-fried foods every single day of the week, it’s still fun to enjoy the occasional golden brown and crunchy treat. A Fry Daddy Jr. only costs about $25 and makes frying an easy task. It heats the oil to temperature within minutes and has a handy storage lid so that you can reuse the oil several times before having to throw it out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Food processor:")]), _vm._v(" We’ve owned processors that cost us next to nothing, as well as others that almost required us parting with a limb. Truth is, we don’t see a big difference between the two. The main thing you want to keep in mind when choosing a processor is size. Consider how many people live in your household and how big your batches of food will be before you buy. As an example, we both use a 10-cup (2.4-l) food processor for a household of two.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Immersion blender:")]), _vm._v(" This magical tool makes for speedy blending right in the bowl, no transfer of food required. We really like our Cuisinart model. It costs under $30 and is going on its sixth year of intensive use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Food scale:")]), _vm._v(" Because we use both weights and measures in our cookbooks, we’ve grown very fond of weighing our ingredients. It makes for easier cleanup (since you can weigh everything right into the mixing bowl, rather than dealing with measuring cups), and is often far more accurate than measuring. It’s possible to find scales for as low as $25 that offer excellent results. We use the Escali brand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Good-quality chef’s knife:")]), _vm._v(" You don’t have to spend hundreds of dollars, but a good chef’s knife with a heavy handle and a blade that can be sharpened at home will save you hours of aggravation, not to mention the cost of bandages from cutting yourself with a frustratingly dull, supercheap version.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Jumbo muffin tins:")]), _vm._v(" If you’re hungry and you know it, whip out your jumbo muffin tin. Each tin yields six bakery-style muffins made of up to 1 cup (235 ml) of batter. Impressive and quite useful when appetites are extreme (or you’re considering baking for profit). As a comparison, standard muffin tins use up to 1/3 cup (80 ml) of batter, so your baking time will likely need to increase by a bit if you’re converting a standard muffin or cupcake recipe.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "chaplev01sec01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('strong', [_vm._v("Microplane grater:")]), _vm._v(" Use it for citrus zest, whole nutmeg, garlic, and anything that requires a close shave.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Silicone baking mats, such as Silpat:")]), _vm._v(" We both swear by them, for one main reason: less waste. Unlike parchment paper, baking mats can be used repeatedly and usually perform for at least 2,000 uses.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Thermometers:")]), _vm._v(" Oven thermometers and instant-read thermometers are an affordable and great way to make sure your oven is well calibrated and that the liquid for your yeast bread is at the adequate temperature.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "chaplev01sec02"
    }
  }, [_vm._v("General Baking and Cooking Tips")])]), _c('a', {
    attrs: {
      "id": "chaplev01sec02"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are a few basic tips we find essential in making our cooking and baking experiences all the more seamless and enjoyable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Be mindful of ingredient temperature.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s best to use ingredients that are at room temperature when baking, but even more so when dealing with yeast bread. The main exception, however, is when making pie crusts and biscuits, where the ingredients should all be very cold. Follow the recommended ingredient temperatures in each recipe—rebelling will only cause regret!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Measure flour correctly.")]), _vm._v(" We use a scoop to transfer flours into the measuring cup, so as not to overpack. It makes a difference in how recipes turn out, so it’s a good thing to keep in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Sift whenever possible.")]), _vm._v(" Sifting after measuring (or before, if the recipe calls for it) helps create light and airy baked goods with an even crumb. Simply use a fine mesh sieve to make sure flour, cocoa powder, baking soda, and other such dry ingredients don’t get over-clumped on you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Practice")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("mise en place")])]), _c('strong', [_vm._v(".")]), _vm._v(" This is French for “Don’t be messy, fool!” (Okay, really it means “everything in place,” but same idea.) To follow this rule, simply gather your ingredients on the counter (and measure out if you’re really feeling organized) in advance, so you won’t have to go looking for the cinnamon when your wet and dry ingredients are already mixed and need to get into the oven pronto. This way, you’ll also allow for things to come to room temperature. (Just don’t do that with things that actually need to be super cold, like nondairy butter for biscuits, or frozen blueberries for muffins!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Read through recipes.")]), _vm._v(" It’s always wise to make sure you’ve got all the ingredients you need and know what you’re in for.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "chaplev01sec02"
    }
  }), _c('a', {
    attrs: {
      "id": "chaplev01sec03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Getting to Know Your Ingredients")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you find yourself scratching the top of your head wondering what on earth maca powder and nutritional yeast are, the following list of ingredients should help you become better acquainted with items that will soon turn out to be indispensable to your vegan pantry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A lot of the ingredients you will come across in this book can be found in any well-stocked supermarket, while less common ingredients may require a trip to your local health food store or a quick visit to the good ole Internet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Beans:")]), _vm._v(" We usually go for canned beans, rinsing and draining them thoroughly to get rid of as much sodium as possible. If you happen to cook your own, we tip our hats to you. You probably already know that one 15-ounce (425 g) can of beans equals approximately 1 2/3 cups (294 g) cooked beans, or 2/3 cup (120 g) dry beans.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Edible seaweed:")]), _vm._v(" Hijiki, dulse, and nori are three edible seaweeds that add a fishy flavor to foods without using fish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Egg replacer:")]), _vm._v(" Although very rarely called for in our recipes, this powder is a handy ingredient to have around the kitchen. Ener-G and Bob’s Red Mill brand egg replacers both make an easy task of replacing eggs in recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Flours:")]), _vm._v(" If you want to get the most nutrition out of your baked goods, consider using whole wheat pastry flour instead of all-purpose flour. Whole wheat pastry flour is ground from soft wheat and is lighter than regular whole wheat flour, so it works particularly well in pastries, cookies, cakes, and the like. (It does not, however, work quite as well in yeast breads due to its low gluten content.) If you can’t find or don’t have whole wheat pastry flour, you can combine equal amounts of unbleached all-purpose and whole wheat flours to get the same results (or just use all all-purpose). Most supermarkets have also started to carry "), _c('em', [_vm._v("white")]), _vm._v(" whole wheat flour, which we find makes for lighter and fluffier breads while still retaining all the nutrition regular whole wheat flour does. We’re big fans of it and recommend using it in yeast breads for less dense results or in combination with all-purpose flour in baked goods, if available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Liquid smoke:")]), _vm._v(" A condiment that’s stocked near the marinades in most markets, this is made by condensing smoke into liquid form. A little goes a long way in giving a smoky flavor to many foods.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Maca powder:")]), _vm._v(" This dried root is somewhat of a superfood, because it is packed with vitamins (B), minerals (including calcium), and amino acids, and is said to increase stamina, reduce fatigue, and even enhance libido. It is rather expensive, but a little goes a long way. It has a nutty, almost buttery flavor. It can be sprinkled on oatmeal or other hot cereals for an added nutritional boost. We sneak it into some of our recipes to add richness and depth.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('strong', [_vm._v("Nondairy milks:")]), _vm._v(" We favor unsweetened milk so that it lends itself to pretty much any use, but we aren’t too picky on which kind: soy, almond, rice, whatever we have. Consider trying several to discover what your palate enjoys best.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Nut butters:")]), _vm._v(" Peanuts, almonds, cashews, creamy or crunchy: They’re all fantastic, especially when made of nothing but nuts and a little salt. Most all-natural peanut butters have a tendency to separate in the jar, requiring a good stir; sometimes this can cause a problem in our recipes. Luckily, there are several all-natural creamy peanut butters (including Earth Balance and MaraNatha) that are clearly labeled as no-stir, and believe it or not, they really are! When necessary, we specify when no-stir peanut butter is needed in our recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Nutritional yeast:")]), _vm._v(" This is a nonactive kind of yeast you’ll either love, hate, or learn to appreciate. Its nutty and cheesy flavor is a bit of an acquired taste, so give yourself time to get used to it. Look for the vegetarian-support formula (this will be noted on the label), which is enriched in vitamin B12.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Oils:")]), _vm._v(" Use neutral-flavored vegetable oils (such as canola, vegetable, peanut, etc.) in baking, unless otherwise mentioned. When it comes to cooking, we favor peanut oil for dishes that involve a long frying time because it has a high smoke point. For salads, we like extra-virgin olive oil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We recognize that some people feel that canola and coconut oil are the evil duo of the greasy world. The charges against them include GMO issues for the former, and saturated fats for the latter. If this is a concern, you can always opt to replace them with peanut or vegetable oil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Orange marmalade:")]), _vm._v(" You will find this in several of our recipes, because we love its bold flavor. Look for the kind that has no sugar or artificial sweetener added: It isn’t bitter at all. Try Smucker’s Simply Fruit or St. Dalfour brands.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Salt and pepper:")]), _vm._v(" We want to respect your habits when it comes to salt and pepper, so the measurements you will find in our recipes are meant as a guideline. You will usually see “to taste” added after these two ingredients so that you can follow your needs and preferences.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The salt you are most likely to find in our kitchens is sea salt, because it retains some minerals, albeit a minuscule amount. We have been known to add a small amount of black salt in recipes that aim to replicate eggs, because it lends a delicate sulfurous flavor to foods.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Sambal oelek:")]), _vm._v(" Spicy sauce made of chiles, vinegar, and salt, this condiment is available at most supermarkets in the international food section.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Soy sauce:")]), _vm._v(" If you prefer tamari or Bragg’s Liquid Aminos, they are all interchangeable. We like to use the reduced-sodium kind so as to have control over the saltiness of our food. The liquid aminos only contain a small amount of natural sodium and happen to be gluten free.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Spices and herbs:")]), _vm._v(" Sometimes we call for fresh herbs and spices, and sometimes we call for dried in our recipes. Unless otherwise noted, you can use either, but of course, fresh is best whenever available. As a general rule, 1 part dried herb is the equivalent of 3 parts fresh.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('strong', [_vm._v("Sriracha:")]), _vm._v(" This hot sauce is made from chile peppers, garlic, vinegar, and salt ground together to form a smooth paste. Check the ingredient list carefully, because some brands contain fish sauce.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Sweeteners:")]), _vm._v(" We most commonly use organic evaporated cane juice (guaranteed to be vegan, as opposed to most brands of granulated cane sugar), organic beet sugar, organic brown sugar, Sucanat, and raw sugar. As for the liquid sweeteners, why not try agave nectar, pure maple syrup, and brown rice syrup? We love them, too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Tofu and tempeh:")]), _vm._v(" Silken tofu is most frequently used for desserts and sauces, and extra firm or even super firm (yes, there is such a thing!) is best for frying and baking. Be sure to press the tofu if you’re going to fry it, because it makes for a chewier and meatier texture. To press, drain the block and then sandwich it between either two folded kitchen towels or several folded layers of paper towels. Place a heavy object (a book or frying pan) on top to press out excess moisture, and let sit for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("TVP (textured vegetable protein):")]), _vm._v(" These granules are used to replicate and replace ground meats in many of our recipes. TVP is inexpensive and found in most health food stores. Made from defatted soy flour, this gluten-free staple will become a must-have in your kitchen. We mostly stick to the small granules, but the larger chunks can also come in handy for stir-fries, soups, and curries.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Vital wheat gluten flour:")]), _vm._v(" A perfect source of protein, this flour is sometimes used in breads to improve texture and is also used to prepare seitan, also known as "), _c('em', [_vm._v("wheat meat")]), _vm._v(". Gluten is the natural protein portion removed from whole wheat. It can be found in most grocery stores or ordered online. Keep in mind that vital wheat gluten flour is completely different from high-gluten flour: these two are not interchangeable and will not perform similarly in recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Yeast:")]), _vm._v(" We use active dry yeast in our recipes, unless otherwise noted, because it is readily available in markets. It is sold in either strips of three envelopes or in small jars. One envelope is equal to 2 1/4 teaspoons (1/4 ounce, or 7 g).")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "chaplev01sec04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Food Allergies and Recipe Icons")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We have done our best to label our recipes, but allergens still have a way of sneaking into ingredients. Please closely monitor all food labels, and contact food manufacturers when in doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Throughout this book you will find recipes labeled in the following way:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-01.jpg"
    }
  }), _c('br'), _c('strong', [_vm._v("Gluten Free:")]), _vm._v(" Recipes that do not contain gluten. Double-check ingredient labels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-02.jpg"
    }
  }), _c('br'), _c('strong', [_vm._v("Low Fat:")]), _vm._v(" Recipes that contain 3 grams (the equivalent of 27 fat calories) of fat, or less, per serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-03.jpg"
    }
  }), _c('br'), _c('strong', [_vm._v("Quick and Easy:")]), _vm._v(" Recipes that take less than 30 minutes to whip up, provided you have intermediate cooking and/or baking skills.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-04.jpg"
    }
  }), _c('br'), _c('strong', [_vm._v("Soy Free:")]), _vm._v(" Recipes that do not contain soy. Double-check ingredient labels.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-green"
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_c('strong', [_vm._v("EAT YOUR VEGGIES!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You know your mama was right all along—munching on your greens "), _c('em', [_vm._v("is")]), _vm._v(" important and a great way to balance out the slightly more exuberant dishes you’ll just have to try out from this book. Find hints as to what veggies or salads we like to pair certain recipes with by using this sidebar as your guide.")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "475px",
      "src": "images/f0018-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0